import $http from '@Config/axios';

export const ExtraPresenter = {
	updateFarmeOSBox: boxes => $http.put('updateFarmeOSBox', { boxes })
};
